import { type Team } from "@/api/team";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TeamStoreState {
  selectedTeam: Team | null;
  selectedTeamId: number | null;
  defaultTeamId: number | null;
  setSelectedTeam: (team: Team | null) => void;
  setDefaultTeamId: (id: number | null) => void;
}

export const useTeamStore = create<TeamStoreState>()(
  persist(
    (set) => ({
      selectedTeam: null,
      selectedTeamId: null,
      defaultTeamId: null,
      setSelectedTeam: (team) => set({ selectedTeam: team, selectedTeamId: team?.id ?? null }),
      setDefaultTeamId: (defaultTeamId) => set({ defaultTeamId }),
    }),
    {
      name: "selected-team",
      partialize: (state) => ({ selectedTeamId: state.selectedTeamId, defaultTeamId: state.defaultTeamId }),
    },
  ),
);
